export const GET_POSITION = 'GET_POSITION';
export const GET_POSITION_SUCCESS = 'GET_POSITION_SUCCESS';
export const GET_POSITION_FAILURE = 'GET_POSITION_FAILURE';

export const GET_POSITION_DETAILS_BY_ID_EMPLOYEE = 'GET_POSITION_DETAILS_BY_ID_EMPLOYEE';
export const GET_POSITION_DETAILS_BY_ID_EMPLOYEE_SUCCESS = 'GET_POSITION_DETAILS_BY_ID_EMPLOYEE_SUCCESS';
export const GET_POSITION_DETAILS_BY_ID_EMPLOYEE_FAILURE = 'GET_POSITION_DETAILS_BY_ID_EMPLOYEE_FAILURE';

export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAILURE = 'GET_ALL_USERS_FAILURE ';

export const POST_POSITION = 'POST_POSITION';
export const POST_POSITION_SUCCESS = 'POST_POSITION_SUCCESS';
export const POST_POSITION_FAILURE = 'POST_POSITION_FAILURE';

export const GET_CANDIDATE = 'GET_CANDIDATE';
export const GET_CANDIDATE_SUCCESS = 'GET_CANDIDATE_SUCCESS';
export const GET_CANDIDATE_FAILURE = 'GET_CANDIDATE_FAILURE';

export const POST_CANDIDATE = 'POST_CANDIDATE';
export const POST_CANDIDATE_SUCCESS = 'POST_CANDIDATE_SUCCESS';
export const POST_CANDIDATE_FAILURE = 'POST_CANDIDATE_FAILURE';

export const POST_BULK_CANDIDATE = 'POST_BULK_CANDIDATE';
export const POST_BULK_CANDIDATE_SUCCESS = 'POST_BULK_CANDIDATE_SUCCESS';
export const POST_BULK_CANDIDATE_FAILURE = 'POST_BULK_CANDIDATE_FAILURE';

export const POST_QUESTION = 'POST_QUESTION';
export const POST_QUESTION_SUCCESS = 'POST_QUESTION_SUCCESS';
export const POST_QUESTION_FAILURE = 'POST_QUESTION_FAILURE';

export const DELETE_QUESTION_SET = 'DELETE_QUESTION_SET';
export const DELETE_QUESTION_SET_SUCCESS = 'DELETE_QUESTION_SET_SUCCESS';
export const DELETE_QUESTION_SET_FAILURE = 'DELETE_QUESTION_SET_FAILURE';

export const GET_QUESTIONS = 'GET_QUESTIONS';
export const GET_QUESTIONS_SUCCESS = 'GET_QUESTIONS_SUCCESS';
export const GET_QUESTIONS_FAILURE = 'GET_QUESTIONS_FAILURE';

export const UPDATE_POSITION_STATUS = 'UPDATE_POSITION_STATUS';
export const UPDATE_POSITION_STATUS_SUCCESS = 'UPDATE_POSITION_STATUS_SUCCESS';
export const UPDATE_POSITION_STATUS_FAILURE = 'UPDATE_POSITION_STATUS_FAILURE';

export const CANCEL_INTERVIEW = 'CANCEL_INTERVIEW';
export const CANCEL_INTERVIEW_SUCCESS = 'CANCEL_INTERVIEW_SUCCESS';
export const CANCEL_INTERVIEW_FAILURE = 'CANCEL_INTERVIEW_FAILURE';

export const GENERATE_LINK = 'GENERATE_LINK';
export const GENERATE_LINK_SUCCESS = 'GENERATE_LINK_SUCCESS';
export const GENERATE_LINK_FAILURE = 'GENERATE_LINK_FAILURE';

export const GENERATE_QUESTION = 'GENERATE_QUESTION';
export const GENERATE_QUESTION_SUCCESS = 'GENERATE_QUESTION_SUCCESS';
export const GENERATE_QUESTION_FAILURE = 'GENERATE_QUESTION_FAILURE';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';

export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_PRODUCT_LIST_SUCCESS = 'GET_PRODUCT_LIST_SUCCESS';
export const GET_PRODUCT_LIST_FAILURE = 'GET_PRODUCT_LIST_FAILURE';

export const GET_NOTIFICATION_LIST = 'GET_NOTIFICATION_LIST';
export const GET_NOTIFICATION_LIST_SUCCESS = 'GET_NOTIFICATION_LIST_SUCCESS';
export const GET_NOTIFICATION_LIST_FAILURE = 'GET_NOTIFICATION_LIST_FAILURE';

export const READ_NOTIFICATION_LIST = 'READ_NOTIFICATION_LIST';
export const READ_NOTIFICATION_LIST_SUCCESS = 'READ_NOTIFICATION_LIST_SUCCESS';
export const READ_NOTIFICATION_LIST_FAILURE = 'READ_NOTIFICATION_LIST_FAILURE';

export const CLEAR_NOTIFICATION_LIST = 'CLEAR_NOTIFICATION_LIST';
export const CLEAR_NOTIFICATION_LIST_SUCCESS = 'CLEAR_NOTIFICATION_LIST_SUCCESS';
export const CLEAR_NOTIFICATION_LIST_FAILURE = 'CLEAR_NOTIFICATION_LIST_FAILURE';

export const GET_USER_PERMISSION = 'GET_USER_PERMISSION';
export const GET_USER_PERMISSION_SUCCESS = 'GET_USER_PERMISSION_SUCCESS';
export const GET_USER_PERMISSION_FAILURE = 'GET_USER_PERMISSION_FAILURE';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';

export const GET_DASHBOARD_DETAILS = 'GET_DASHBOARD_DETAILS';
export const GET_DASHBOARD_DETAILS_SUCCESS = 'GET_DASHBOARD_DETAILS_SUCCESS';
export const GET_DASHBOARD_DETAILS_FAILURE = 'GET_DASHBOARD_DETAILS_FAILURE';

export const GET_DOMAIN = 'GET_DOMAIN';
export const GET_DOMAIN_SUCCESS = 'GET_DOMAIN_SUCCESS';
export const GET_DOMAIN_FAILURE = 'GET_DOMAIN_FAILURE';

export const GET_POSITION_LIST = 'GET_POSITION_LIST';
export const GET_POSITION_LIST_SUCCESS = 'GET_POSITION_LIST_SUCCESS';
export const GET_POSITION_LIST_FAILURE = 'GET_POSITION_LIST_FAILURE';

export const GET_WHITE_LABEL = 'GET_WHITE_LABEL';
export const GET_WHITE_LABEL_SUCCESS = 'GET_WHITE_LABEL_SUCCESS';
export const GET_WHITE_LABEL_FAILURE = 'GET_WHITE_LABEL_FAILURE';

export const GET_DROPDOWN_QUESTION = 'GET_DROPDOWN_QUESTION';
export const GET_DROPDOWN_QUESTION_SUCCESS = 'GET_DROPDOWN_QUESTION_SUCCESS';
export const GET_DROPDOWN_QUESTION_FAILURE = 'GET_DROPDOWN_QUESTION_FAILURE';

export const GET_DROPDOWN_POSITION = 'GET_DROPDOWN_POSITION';
export const GET_DROPDOWN_POSITION_SUCCESS = 'GET_DROPDOWN_POSITION_SUCCESS';
export const GET_DROPDOWN_POSITION_FAILURE = 'GET_DROPDOWN_POSITION_FAILURE';

export const GET_CANDIDATE_DETAILS_USING_RESUME = 'GET_CANDIDATE_DETAILS_USING_RESUME';
export const GET_CANDIDATE_DETAILS_USING_RESUME_SUCCESS = 'GET_CANDIDATE_DETAILS_USING_RESUME_SUCCESS';
export const GET_CANDIDATE_DETAILS_USING_RESUME_FAILURE = 'GET_CANDIDATE_DETAILS_USING_RESUME_FAILURE';

export const RESEND_EMAIL = 'RESEND_EMAIL';
export const RESEND_EMAIL_SUCCESS = 'RESEND_EMAIL_SUCCESS';
export const RESEND_EMAIL_FAILURE = 'RESEND_EMAIL_FAILURE';

export const COMPARE_JD_CV = 'COMPARE_JD_CV';
export const COMPARE_JD_CV_SUCCESS = 'COMPARE_JD_CV_SUCCESS';
export const COMPARE_JD_CV_FAILURE = 'COMPARE_JD_CV_FAILURE';

export const RESUME_INTERVIEW = 'RESUME_INTERVIEW';
export const RESUME_INTERVIEW_SUCCESS = 'RESUME_INTERVIEW_SUCCESS';
export const RESUME_INTERVIEW_FAILURE = 'RESUME_INTERVIEW_FAILURE';

export const MANUAL_INVITE = 'MANUAL_INVITE';
export const MANUAL_INVITE_SUCCESS = 'MANUAL_INVITE_SUCCESS';
export const MANUAL_INVITE_FAILURE = 'MANUAL_INVITE_FAILURE';

export const FETCH_RESUME_SCORE = 'FETCH_RESUME_SCORE';
export const FETCH_RESUME_SCORE_SUCCESS = 'FETCH_RESUME_SCORE_SUCCESS';
export const FETCH_RESUME_SCORE_FAILURE = 'FETCH_RESUME_SCORE_FAILURE';

export const MANUAL_CALL_END = 'MANUAL_CALL_END';
export const MANUAL_CALL_END_SUCCESS = 'MANUAL_CALL_END_SUCCESS';
export const MANUAL_CALL_END_FAILURE = 'MANUAL_CALL_END_FAILURE';

export const GET_ALL_PERMISSION = 'GET_ALL_PERMISSION';
export const GET_ALL_PERMISSION_SUCCESS = 'GET_ALL_PERMISSION_SUCCESS';
export const GET_ALL_PERMISSION_FAILURE = 'GET_ALL_PERMISSION_FAILURE';

export const GET_BANNERS = 'GET_BANNERS';
export const GET_BANNERS_SUCCESS = 'GET_BANNERS_SUCCESS';
export const GET_BANNERS_FAILURE = 'GET_BANNERS_FAILURE';

export const CREATE_CANDIDATES = 'CREATE_CANDIDATES';
export const CREATE_CANDIDATES_SUCCESS = 'CREATE_CANDIDATES_SUCCESS';
export const CREATE_CANDIDATES_FAILURE = 'CREATE_CANDIDATES_FAILURE';
// ===========================================SKILLS==================================//
export const GET_MANDATORY_SKILL = 'GET_MANDATORY_SKILL';
export const GET_MANDATORY_SKILL_SUCCESS = 'GET_MANDATORY_SKILL_SUCCESS';
export const GET_MANDATORY_SKILL_FAILURE = 'GET_MANDATORY_SKILL_FAILURE';

export const GET_OPTIONAL_SKILL = 'GET_OPTIONAL_SKILL';
export const GET_OPTIONAL_SKILL_SUCCESS = 'GET_OPTIONAL_SKILL_SUCCESS';
export const GET_OPTIONAL_SKILL_FAILURE = 'GET_OPTIONAL_SKILL_FAILURE';

export const FETCH_SKILLS = 'FETCH_SKILLS';
export const FETCH_SKILLS_SUCCESS = 'FETCH_SKILLS_SUCCESS';
export const FETCH_SKILLS_FAILURE = 'FETCH_SKILLS_FAILURE';

export const FETCH_SKILLS_JD = 'FETCH_SKILLS_JD';
export const FETCH_SKILLS_JD_SUCCESS = 'FETCH_SKILLS_JD_SUCCESS';
export const FETCH_SKILLS_JD_FAILURE = 'FETCH_SKILLS_JD_FAILURE';
// ===========================================SKILLS==================================//
export const FETCH_LOGO = 'FETCH_LOGO';
export const FETCH_LOGO_SUCCESS = 'FETCH_LOGO_SUCCESS';
export const FETCH_LOGO_FAILURE = 'FETCH_LOGO_FAILURE';

//===========================================CONFIGURATIONS===========================//
export const GET_CONFIGURATIONS = 'GET_CONFIGURATIONS';
export const GET_CONFIGURATIONS_SUCCESS = 'GET_CONFIGURATIONS_SUCCESS';
export const GET_CONFIGURATIONS_FAILURE = 'GET_CONFIGURATIONS_FAILURE';
//===================================CANDIDATE_BANK===================================//

export const CHECK_CANDIDATE_BANK_EXISTS = 'CHECK_CANDIDATE_BANK_EXISTS';
export const CHECK_CANDIDATE_BANK_EXISTS_SUCCESS = 'CHECK_CANDIDATE_BANK_EXISTS_SUCCESS';
export const CHECK_CANDIDATE_BANK_EXISTS_FAILURE = 'CHECK_CANDIDATE_BANK_EXISTS_FAILURE';

export const ADD_CANDIDATE_BANK = 'ADD_CANDIDATE_BANK';
export const ADD_CANDIDATE_BANK_SUCCESS = 'ADD_CANDIDATE_BANK_SUCCESS';
export const ADD_CANDIDATE_BANK_FAILURE = 'ADD_CANDIDATE_BANK_FAILURE';

export const GET_CANDIDATE_BANK = 'GET_CANDIDATE_BANK';
export const GET_CANDIDATE_BANK_SUCCESS = 'GET_CANDIDATE_BANK_SUCCESS';
export const GET_CANDIDATE_BANK_FAILURE = 'GET_CANDIDATE_BANK_FAILURE';

export const EDIT_CANDIDATE_BANK = 'EDIT_CANDIDATE_BANK';
export const EDIT_CANDIDATE_BANK_SUCCESS = 'EDIT_CANDIDATE_BANK_SUCCESS';
export const EDIT_CANDIDATE_BANK_FAILURE = 'EDIT_CANDIDATE_BANK_FAILURE';

export const DELETE_CANDIDATE_BANK = 'DELETE_CANDIDATE_BANK';
export const DELETE_CANDIDATE_BANK_SUCCESS = 'DELETE_CANDIDATE_BANK_SUCCESS';
export const DELETE_CANDIDATE_BANK_FAILURE = 'DELETE_CANDIDATE_BANK_FAILURE';

export const GET_CANDIDATE_BANK_LIST = 'GET_CANDIDATE_BANK_LIST';
export const GET_CANDIDATE_BANK_LIST_SUCCESS = 'GET_CANDIDATE_BANK_LIST_SUCCESS';
export const GET_CANDIDATE_BANK_LIST_FAILURE = 'GET_CANDIDATE_BANK_LIST_FAILURE';

export const DELETE_CANDIDATE_BANK_LIST = 'DELETE_CANDIDATE_BANK_LIST';
export const DELETE_CANDIDATE_BANK_LIST_SUCCESS = 'DELETE_CANDIDATE_BANK_LIST_SUCCESS';
export const DELETE_CANDIDATE_BANK_LIST_FAILURE = 'DELETE_CANDIDATE_BANK_LIST_FAILURE';

export const ADD_EDIT_CANDIDATE_BANK_LIST = 'ADD_EDIT_CANDIDATE_BANK_LIST';
export const ADD_EDIT_CANDIDATE_BANK_LIST_SUCCESS = 'ADD_EDIT_CANDIDATE_BANK_LIST_SUCCESS';
export const ADD_EDIT_CANDIDATE_BANK_LIST_FAILURE = 'ADD_EDIT_CANDIDATE_BANK_LIST_FAILURE';

export const GET_CANDIDATE_BANK_DROPDOWN_LIST = 'GET_CANDIDATE_BANK_DROPDOWN_LIST';
export const GET_CANDIDATE_BANK_DROPDOWN_LIST_SUCCESS = 'GET_CANDIDATE_BANK_DROPDOWN_LIST_SUCCESS';
export const GET_CANDIDATE_BANK_DROPDOWN_LIST_FAILURE = 'GET_CANDIDATE_BANK_DROPDOWN_LIST_FAILURE';

//===========================================Subscription Data=====================================//
export const GET_SUBSCRIPTION_DATA = 'GET_SUBSCRIPTION_DATA';
export const GET_SUBSCRIPTION_DATA_SUCCESS = 'GET_SUBSCRIPTION_DATA_SUCCESS';
export const GET_SUBSCRIPTION_DATA_FAILURE = 'GET_SUBSCRIPTION_DATA_FAILURE';

export const GET_QUESTION_LIBRARY = 'GET_QUESTION_LIBRARY';
export const GET_QUESTION_LIBRARY_SUCCESS = 'GET_QUESTION_LIBRARY_SUCCESS';
export const GET_QUESTION_LIBRARY_FAILURE = 'GET_QUESTION_LIBRARY_FAILURE';

export const PUT_FINAL_OUTCOME = 'PUT_FINAL_OUTCOME';
export const PUT_FINAL_OUTCOME_SUCCESS = 'PUT_FINAL_OUTCOME_SUCCESS';
export const PUT_FINAL_OUTCOME_FAILURE = 'PUT_FINAL_OUTCOME_FAILURE';

// Global Fields
export const GET_GLOBAL_FIELDS = 'GET_GLOBAL_FIELDS';
export const GET_GLOBAL_FIELDS_SUCCESS = 'GET_GLOBAL_FIELDS_SUCCESS';
export const GET_GLOBAL_FIELDS_FAILURE = 'GET_GLOBAL_FIELDS_FAILURE';

// Candidate Global Fields
export const GET_CANDIDATE_GLOBAL_FIELDS = 'GET_CANDIDATE_GLOBAL_FIELDS';
export const GET_CANDIDATE_GLOBAL_FIELDS_SUCCESS = 'GET_CANDIDATE_GLOBAL_FIELDS_SUCCESS';
export const GET_CANDIDATE_GLOBAL_FIELDS_FAILURE = 'GET_CANDIDATE_GLOBAL_FIELDS_FAILURE';

export const GET_CANDIDATE_STATUS_FILTERS = 'GET_CANDIDATE_STATUS_FILTERS';
export const GET_CANDIDATE_STATUS_FILTERS_SUCCESS = 'GET_CANDIDATE_STATUS_FILTERS_SUCCESS';
export const GET_CANDIDATE_STATUS_FILTERS_FAILURE = 'GET_CANDIDATE_STATUS_FILTERS_FAILURE';

export const GET_INTERVIEW_DETAILS_BY_ID_EMPLOYEE = 'GET_INTERVIEW_DETAILS_BY_ID_EMPLOYEE';
export const GET_INTERVIEW_DETAILS_BY_ID_EMPLOYEE_SUCCESS = 'GET_INTERVIEW_DETAILS_BY_ID_EMPLOYEE_SUCCESS';
export const GET_INTERVIEW_DETAILS_BY_ID_EMPLOYEE_FAILURE = 'GET_INTERVIEW_DETAILS_BY_ID_EMPLOYEE_FAILURE';

export const GET_INCBOT_INTERVIEW_MONTHLY_STATS = 'GET_INCBOT_INTERVIEW_MONTHLY_STATS';
export const GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS = 'GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS';
export const GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE = 'GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE';
export const GET_INCBOT_SUBUSER_INTERVIEW_MONTHLY_STATS = 'GET_INCBOT_SUBUSER_INTERVIEW_MONTHLY_STATS';
export const GET_INCBOT_SUBUSER_INTERVIEW_MONTHLY_STATS_SUCCESS = 'GET_INCBOT_SUBUSER_INTERVIEW_MONTHLY_STATS_SUCCESS';
export const GET_INCBOT_SUBUSER_INTERVIEW_MONTHLY_STATS_FAILURE = 'GET_INCBOT_SUBUSER_INTERVIEW_MONTHLY_STATS_FAILURE';

export const GET_INTERVIEW_INC_SCREEN = 'GET_INTERVIEW_INC_SCREEN';
export const GET_INTERVIEW_INC_SCREEN_SUCCESS = 'GET_INTERVIEW_INC_SCREEN_SUCCESS';
export const GET_INTERVIEW_INC_SCREEN_FAILURE = 'GET_INTERVIEW_INC_SCREEN_FAILURE';

export const GET_USER_INFORMATION = 'GET_USER_INFORMATION';
export const GET_USER_INFORMATION_SUCCESS = 'GET_USER_INFORMATION_SUCCESS';
export const GET_USER_INFORMATION_FAILURE = 'GET_USER_INFORMATION_FAILURE';

export const GET_CONFIGURATIONS_FOR_INSTRUCTIONS = 'GET_CONFIGURATIONS_FOR_INSTRUCTIONS';
export const GET_CONFIGURATIONS_FOR_INSTRUCTIONS_SUCCESS = 'GET_CONFIGURATIONS_FOR_INSTRUCTIONS_SUCCESS';
export const GET_CONFIGURATIONS_FOR_INSTRUCTIONS_FAILURE = 'GET_CONFIGURATIONS_FOR_INSTRUCTIONS_FAILURE';

export const FETCH_LANGUAGE_QUESTION = 'FETCH_LANGUAGE_QUESTION';
export const FETCH_LANGUAGE_QUESTION_SUCCESS = 'FETCH_LANGUAGE_QUESTION_SUCCESS';
export const FETCH_LANGUAGE_QUESTION_FAILURE = 'FETCH_LANGUAGE_QUESTION_FAILURE';
export const TRANSLATE_QUESTIONS = 'TRANSLATE_QUESTIONS';
export const TRANSLATE_QUESTIONS_SUCCESS = 'TRANSLATE_QUESTIONS_SUCCESS';
export const TRANSLATE_QUESTIONS_FAILURE = 'TRANSLATE_QUESTIONS_FAILURE';
export const FETCH_PSYCHOMETRIC_ROLES = 'FETCH_PSYCHOMETRIC_ROLES';
export const FETCH_PSYCHOMETRIC_ROLES_SUCCESS = 'FETCH_PSYCHOMETRIC_ROLES_SUCCESS';
export const FETCH_PSYCHOMETRIC_ROLES_FAILURE = 'FETCH_PSYCHOMETRIC_ROLES_FAILURE';

export const GET_DASHBOARD_INTERVIEWS = 'GET_DASHBOARD_INTERVIEWS';
export const GET_DASHBOARD_INTERVIEWS_SUCCESS = 'GET_DASHBOARD_INTERVIEWS_SUCCESS';
export const GET_DASHBOARD_INTERVIEWS_FAILURE = 'GET_DASHBOARD_INTERVIEWS_FAILURE';

export const GET_FINAL_OUTCOMES = 'GET_FINAL_OUTCOMES';
export const GET_FINAL_OUTCOMES_SUCCESS = 'GET_FINAL_OUTCOMES_SUCCESS';
export const GET_FINAL_OUTCOMES_FAILURE = 'GET_FINAL_OUTCOMES_FAILURE';

export const GET_FEEDBACK_STATUS = 'GET_FEEDBACK_STATUS';
export const GET_FEEDBACK_STATUS_SUCCESS = 'GET_FEEDBACK_STATUS_SUCCESS';
export const GET_FEEDBACK_STATUS_FAILURE = 'GET_FEEDBACK_STATUS_FAILURE';

export const GET_POSITIONS_SUMMARY = 'GET_POSITIONS_SUMMARY';
export const GET_POSITIONS_SUMMARY_SUCCESS = 'GET_POSITIONS_SUMMARY_SUCCESS';
export const GET_POSITIONS_SUMMARY_FAILURE = 'GET_POSITIONS_SUMMARY_FAILURE';

export const GET_TOP_POSITIONS = 'GET_TOP_POSITIONS';
export const GET_TOP_POSITIONS_SUCCESS = 'GET_TOP_POSITIONS_SUCCESS';
export const GET_TOP_POSITIONS_FAILURE = 'GET_TOP_POSITIONS_FAILURE';

export const GET_POSITION_ANALYTICS = 'GET_POSITION_ANALYTICS';
export const GET_POSITION_ANALYTICS_SUCCESS = 'GET_POSITION_ANALYTICS_SUCCESS';
export const GET_POSITION_ANALYTICS_FAILURE = 'GET_POSITION_ANALYTICS_FAILURE';

export const GET_INTERVIEW_COMPLETED = 'GET_INTERVIEW_COMPLETED';
export const GET_INTERVIEW_COMPLETED_SUCCESS = 'GET_INTERVIEW_COMPLETED_SUCCESS';
export const GET_INTERVIEW_COMPLETED_FAILURE = 'GET_INTERVIEW_COMPLETED_FAILURE';

export const GET_TOTAL_INTERVIEWS = 'GET_TOTAL_INTERVIEWS';
export const GET_TOTAL_INTERVIEWS_SUCCESS = 'GET_TOTAL_INTERVIEWS_SUCCESS';
export const GET_TOTAL_INTERVIEWS_FAILURE = 'GET_TOTAL_INTERVIEWS_FAILURE';

export const GET_INTERVIEW_COMPLETED_SUMMARY = 'GET_INTERVIEW_COMPLETED_SUMMARY';
export const GET_INTERVIEW_COMPLETED_SUMMARY_SUCCESS = 'GET_INTERVIEW_COMPLETED_SUMMARY_SUCCESS';
export const GET_INTERVIEW_COMPLETED_SUMMARY_FAILURE = 'GET_INTERVIEW_COMPLETED_SUMMARY_FAILURE';

export const LOGIN_USER_DEVICE_CHECK = 'LOGIN_USER_DEVICE_CHECK';
export const LOGIN_USER_DEVICE_CHECK_SUCCESS = 'LOGIN_USER_DEVICE_CHECK_SUCCESS';
export const LOGIN_USER_DEVICE_CHECK_FAILURE = 'LOGIN_USER_DEVICE_CHECK_FAILURE';

export const SUBMIT_NPS = 'SUBMIT_NPS';
export const SUBMIT_NPS_SUCCESS = 'SUBMIT_NPS_SUCCESS';
export const SUBMIT_NPS_FAILURE = 'SUBMIT_NPS_FAILURE';

export const NPS_HANDLE = 'NPS_HANDLE';
export const NPS_HANDLE_SUCCESS = 'NPS_HANDLE_SUCCESS';

// ============================== CSAT (Candidate Satisfaction) ============================== //
export const SUBMIT_CSAT = 'SUBMIT_CSAT';
export const SUBMIT_CSAT_SUCCESS = 'SUBMIT_CSAT_SUCCESS';
export const SUBMIT_CSAT_FAILURE = 'SUBMIT_CSAT_FAILURE';

export const CSAT_HANDLE = 'CSAT_HANDLE';
export const CSAT_HANDLE_SUCCESS = 'CSAT_HANDLE_SUCCESS';

export const GET_WHATS_NEW = 'GET_WHATS_NEW';
export const GET_WHATS_NEW_SUCCESS = 'GET_WHATS_NEW_SUCCESS';
export const GET_WHATS_NEW_FAILURE = 'GET_WHATS_NEW_FAILURE';

export const GET_DASHBOARD_USER_POSITIONS = 'GET_DASHBOARD_USER_POSITIONS';
export const GET_DASHBOARD_USER_POSITIONS_SUCCESS = 'GET_DASHBOARD_USER_POSITIONS_SUCCESS';
export const GET_DASHBOARD_USER_POSITIONS_FAILURE = 'GET_DASHBOARD_USER_POSITIONS_FAILURE';

export const GET_DASHBOARD_SUBUSER_LIST = 'GET_DASHBOARD_SUBUSER_LIST';
export const GET_DASHBOARD_SUBUSER_LIST_SUCCESS = 'GET_DASHBOARD_SUBUSER_LIST_SUCCESS';
export const GET_DASHBOARD_SUBUSER_LIST_FAILURE = 'GET_DASHBOARD_SUBUSER_LIST_FAILURE';

export const REINVITE_UNATTENDED = 'REINVITE_UNATTENDED';
export const REINVITE_UNATTENDED_SUCCESS = 'REINVITE_UNATTENDED_SUCCESS';
export const REINVITE_UNATTENDED_FAILURE = 'REINVITE_UNATTENDED_FAILURE';
